/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySide';
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptions interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptions(value) {
    if (!('Image' in value) || value['Image'] === undefined)
        return false;
    if (!('Type' in value) || value['Type'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Image': json['Image'],
        'Type': json['Type'],
        'SideBySide': json['SideBySide'] == null ? undefined : FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideFromJSON(json['SideBySide']),
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Image': value['Image'],
        'Type': value['Type'],
        'SideBySide': FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideToJSON(value['SideBySide']),
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptions.js.map